import PublicActivityType from '@/pages/publicPages/PublicActivityType/PublicActivityType';
import PublicActivityTypeSSP from '@/pages/publicPages/PublicActivityType/PublicActivityType.ssp';
import PageMetadata from '@/v2/domains/SEO/components/PageMetadata/PageMetadata';

export default function Songs(props) {
  return (
    <>
      <PageMetadata
        title="Spanish songs for kids | Rockalingua"
        description="Best songs to learn spanish for kids"
      />
      <PublicActivityType {...props.pageProps} />
    </>
  );
}

export const getServerSideProps = async (context) =>
  await PublicActivityTypeSSP({ context, activityType: 'song' });
